
export const getImageUrl = (imagePath: string): string => {
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  return `${process.env.REACT_APP_API_ENDPOINT}${imagePath}`;
};

// Reorders images so the primary one is at index 0; hero, thumbnails and gallery all index this array.
export const primaryImageFirst = <T extends { is_primary?: boolean }>(images: T[] = []): T[] => {
  const primary = images.find(img => img.is_primary);
  return primary ? [primary, ...images.filter(img => img !== primary)] : images;
};
